import { YhBox } from "@/components/YhBox";
import { BillDataTable } from "./BillDataTable";
import { BillSearchBox } from "./BillSearchBox";

export const BillDataBox = () => {

    return (
        <>
            <BillSearchBox />
            <YhBox >
                <BillDataTable />
            </YhBox>
        </>
    )
}
